import React from "react";
import { Quote, Star } from "lucide-react";

const TestimonialsSection = () => {
  const testimonials = [
    {
      type: "parent",
      name: "María González",
      role: "Madre de Diego (10 años)",
      content: "Mi hijo pasó de solo jugar videojuegos a crear sus propios mundos en Minecraft mientras aprende programación. Su pensamiento lógico ha mejorado increíblemente.",
      rating: 5,
      avatar: "https://ui-avatars.com/api/?name=Maria+Gonzalez&background=12C2E9&color=151823&size=64"
    },
    {
      type: "parent", 
      name: "Carlos Ruiz",
      role: "Padre de Sofía (12 años)",
      content: "Lo que más me impresiona es cómo Sofía ahora cuestiona todo de manera constructiva. Ha desarrollado un pensamiento crítico que la ayuda en todas las materiales del colegio.",
      rating: 5,
      avatar: "https://ui-avatars.com/api/?name=Carlos+Ruiz&background=8B5CF6&color=151823&size=64"
    },
    {
      type: "student",
      name: "Alex (13 años)",
      role: "Estudiante",
      content: "Crear mi propio juego en Roblox fue increíble. Ahora entiendo cómo funcionan los videojuegos por dentro y hasta he ganado mis primeros Robux vendiendo mis creaciones.",
      rating: 5,
      avatar: "https://ui-avatars.com/api/?name=Alex&background=FF4D9D&color=151823&size=64"
    }
  ];

  return (
    <section className="testimonials-section" id="testimonials">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">
            Lo que dicen nuestras 
            <span className="title-highlight"> familias lab</span>
          </h2>
          <p className="section-subtitle">
            Resultados reales de padres e hijos que ya viven el futuro.
          </p>
        </div>
        
        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <div className="testimonial-header">
                <Quote className="quote-icon" />
                <div className="testimonial-rating">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="star-icon filled" />
                  ))}
                </div>
              </div>
              
              <blockquote className="testimonial-content">
                "{testimonial.content}"
              </blockquote>
              
              <div className="testimonial-author">
                <img 
                  src={testimonial.avatar}
                  alt={testimonial.name}
                  className="author-avatar"
                />
                <div className="author-info">
                  <div className="author-name">{testimonial.name}</div>
                  <div className="author-role">{testimonial.role}</div>
                </div>
                <div className={`testimonial-badge ${testimonial.type}`}>
                  {testimonial.type === 'parent' ? 'Padre/Madre' : 'Estudiante'}
                </div>
              </div>
              
              <div className="testimonial-glow"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;